import { gql } from '@apollo/client';

export default gql`
  fragment PaymentsPayment on Payment {
    id
    refId
    reference
    currency
    externalReference
    membershipNumber
    method
    isPayout
    isBalance
    isSuccessful
    amount: amountWithCurrency
    amountWithCurrency
    transactionTimestamp
    paymentStatus
    createdRevision
    action @client
    display @client
  }
`;
